import React, { useEffect } from 'react';
import { number } from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getReferralMemos } from 'Redux/modules/webChat/referralMemo/actions';

import EmptyList from '../EmptyList';
import HOCList from '../HOCList';

import MemoItem from './MemoItem';
import style from './Memo.less';

const ReferralMemos = ({ conversationId }) => {
  const dispatch = useDispatch();
  const { metaReferralMemos, referralMemos } = useSelector(
    state => state.webChat.referralMemo,
    shallowEqual,
  );

  const page = metaReferralMemos?.pagination?.page || 0;
  const pages = metaReferralMemos?.pagination?.pages || 0;
  const isLoadMore = page < pages;

  const getListReferralMemo = (curPage, loadMore) => {
    dispatch(getReferralMemos(conversationId, { page: curPage, pageSize: 20 }, loadMore));
  };

  const onEnter = () => {
    if (isLoadMore) {
      getListReferralMemo(page + 1, isLoadMore);
    }
  };

  useEffect(() => {
    getListReferralMemo(1, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className={style.list}>
        <HOCList onEnter={onEnter} isLoadMore={isLoadMore}>
          {referralMemos.map(item => (
            <MemoItem key={item.id} item={item} />
          ))}
        </HOCList>
        {referralMemos.length === 0 && <EmptyList text="No referrals yet" />}
      </div>
    </div>
  );
};

ReferralMemos.propTypes = {
  conversationId: number.isRequired,
};

ReferralMemos.defaultProps = {};

export default ReferralMemos;
